module.exports = new __parcel__URL__("crystalmage.5fbf4fb7.png").toString();